// Takes the status object and an array of strings with elements being service function names
// Returns true if any of the service functions (requests) are still loading
//
// The idea of this function is that if a component depends on service functions A, B, and C
// then we can check if it's loading with
// ```
// const componentIsLoading = lookupIsLoading(state.slice.statusObj, ["A", "B", "C"])
// ```
// where state.slice.statusObj referers to the appropriate slice.
export function lookupIsLoading(statusObj, serviceFunctionNames) {
    return serviceFunctionNames.some(key => statusObj?.[key] == "loading")
}